import { mapActions } from 'vuex';

export default {
  computed: {
    costs() {
      const { settings } = this.$store.state.settings;
      return {
        motor: settings.motor || 0,
        pelmet: settings.pelmet || 0,
        reducer: settings.reducer || 0,
        pelmetRoller: settings.pelmetRoller || 0,
      };
    },
  },
  methods: {
    ...mapActions([
      'getSettings',
    ]),
    calcPelmet(item) {
      const { blinds } = item;
      const cost = (Number(blinds.width) + 0.27) * Number(this.costs.pelmet);
      return this.addOrRemoveCost(item, item.blinds.pelmet, cost);
    },
    addOrRemoveCost(model, input, cost) {
      if (input) {
        model.blinds.additional_cost += Number(cost);
        return model;
      }
      // model.blinds.additional_cost -= Number(cost);
      return model;
    },
    checkPelmetByBlindsType(model) {
      if (model.blinds.blinds_type_id === 3) {
        const cost = Number(model.blinds.width) * Number(this.costs.pelmetRoller);
        return this.addOrRemoveCost(model, model.blinds.pelmet, cost);
      }

      return this.calcPelmet(model);
    },
    calcAdditionalCost(model) {
      model.blinds.additional_cost = 0;
      this.addOrRemoveCost(model, model.blinds.reducer, this.costs.reducer);
      this.addOrRemoveCost(model, model.blinds.hasEngine, this.costs.motor);
      this.checkPelmetByBlindsType(model);
      this.calcTotalWithAdditionalCost(model);
      return model.blinds.additional_cost;
    },
    calcTotal(item) {
      // eslint-disable-next-line
      item.total = Number(item.value) * Number(item.quantity) ;
    },
    calcTotalWithAdditionalCost(item) {
      const subtotal = Number(item.blinds.area) * Number(item.value);
      item.total = Number(item.quantity) * (subtotal + Number(item.blinds.additional_cost));
    },
    calcTotalByArea(item) {
      setTimeout(() => {
        const area = Number(item.blinds.width) * Number(item.blinds.height);
        item.blinds.area = Number(area).toFixed(2);
        this.calcAdditionalCost(item);
        this.calcTotalWithAdditionalCost(item);
      }, 20);
    },
    getSettingsCost() {
      if (this.$store.state.quotation.settings == null) {
        this.setToggle({ type: 'progress', bool: true });
        this.getSettings()
          .then(() => {
            this.setToggle({ type: 'progress', bool: false });
          });
      }
    },
    setTotal(item) {
      if (item.blinds && item.unit_type !== 'un') {
        this.calcTotalByArea(item);
      } else {
        this.calcTotal(item);
      }
      this.calcSubtotal();
    },
  },
  mounted() {
    this.getSettings();
  },
};
